import React from "react";
import { Button, Col, Space } from "antd";

interface FilterActionsProps {
  onReset?: () => void;
  submitText?: string;
  resetText?: string;
}

const FilterActions: React.FC<FilterActionsProps> = ({
  onReset,
  submitText = "Apply Filter",
  resetText = "Clear All",
}) => (
  <Col span={24}>
    <div className="filter-actions mb-2">
      <Space className="d-flex justify-content-end">
        <Button type="primary" htmlType="submit">
          {submitText}
        </Button>
        <Button htmlType="button" onClick={onReset}>
          {resetText}
        </Button>
      </Space>
    </div>
  </Col>
);

export default FilterActions;
